import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { sendPasswordResetEmail } from "firebase/auth";

import { auth } from "../../firebase/firebase.utils";
import AuthLayout from "../../components/layout/auth-layout.component";
import { Button, Field, TextInput } from "../../components/ui";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const toastId = toast.loading("Sending reset email...");
    setIsLoading(true);
    try {
      await sendPasswordResetEmail(auth, email, { url: `${window.location.origin}/signin` });
      toast.update(toastId, {
        render: "An email has been sent to reset your password.",
        type: "success",
        isLoading: false,
        autoClose: 2000,
        delay: 100,
      });
      navigate("/signin");
    } catch (err) {
      console.error(err);
      toast.update(toastId, {
        render:
          err.code === "auth/user-not-found"
            ? "No account exists for that email. Please sign up."
            : "Something went wrong",
        type: "error",
        isLoading: false,
        autoClose: 2000,
        delay: 100,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Reset password"
      subtitle="We'll email you a link to set a new one."
      footer={
        <button onClick={() => navigate("/signin")} className="text-sm font-semibold text-primary-600 hover:underline">
          Back to sign in
        </button>
      }
    >
      <form onSubmit={handleSubmit}>
        <Field label="Email" htmlFor="reset-email">
          <TextInput
            id="reset-email"
            type="email"
            required
            autoFocus
            autoComplete="email"
            value={email}
            placeholder="name@example.com"
            onChange={(e) => setEmail(e.target.value.trim())}
          />
        </Field>

        <Button type="submit" size="lg" loading={isLoading} className="w-full">
          Send reset email
        </Button>
      </form>
    </AuthLayout>
  );
};

export default ForgotPassword;
